import {Box, Fade, useScrollTrigger} from "@mui/material";
import PropTypes from  "prop-types";

const ScrollTop = (props) => {
    const {children} = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector("#toolbar");
        if (anchor)
            anchor.scrollIntoView({block: 'center'});
    };

    ScrollTop.propTypes = {
        children: PropTypes.element.isRequired
    };

    return (
        <Fade in={trigger}>
            <Box
                onClick={handleClick}
                role="presentation"
                sx={{position: 'fixed', bottom: 16, right: 16}}
            >
                {children}
            </Box>
        </Fade>
    );
};

export default ScrollTop;